// UI-only presets are never provider model slugs. Keep route support explicit;
// remote/Codex pickers continue to use the models supplied by their terminal.
export const MODEL_REASONING_PRESETS = [
  {
    id: 'gpt-6-astra-pro',
    label: 'GPT-6 Astra Pro',
    model: 'gpt-6-astra',
    openai_reasoning_mode: 'pro',
    supported_routes: ['backend_henosis', 'byok:openai'],
  },
];

export const getModelReasoningPreset = (selection) => MODEL_REASONING_PRESETS.find(
  (preset) => preset.id === String(selection || '').trim().toLowerCase()
) || null;

// Apply only at inference boundaries, never to saved UI preferences or thread
// selected_model. Preset intent wins over a stale Standard-mode setting.
export const resolveChatModelRequest = (payload = {}, route = 'backend_henosis') => {
  const preset = getModelReasoningPreset(payload?.model);
  if (!preset) return payload || {};
  if (!preset.supported_routes.includes(route)) {
    throw new Error(`${preset.label} is not supported on the ${route} route.`);
  }
  return { ...payload, model: preset.model, openai_reasoning_mode: preset.openai_reasoning_mode };
};
